import React from 'react';
import { getToyAgeRanges } from '../../../../ultraPlanUtils';

const ToyAgeTags = ({ toy }) => {
  const ageRanges = getToyAgeRanges(toy);
  if (!ageRanges?.length) return null;
  return (
    <span className="toy-age-tags">
      {ageRanges?.map((range) => (
        <span key={range} className="toy-age-tag" title={`${range} years`}>
          {range}
        </span>
      ))}
    </span>
  );
};

export default ToyAgeTags;
